<template>
  <div class="row card">
    <!-- Header -->
    <div class="align-items-center">
      <div class="border-0 mb-4">
        <div class="card-header py-3 no-bg bg-transparent d-flex align-items-center px-0 justify-content-between border-bottom flex-wrap">
          <h3 class="fw-bold mb-0">Şablonlar</h3>
          
          <!-- Add Appointment button -->
          <div class="col-auto d-flex w-sm-100">
          </div>
        </div>
      </div>
    </div>

    <div class="row overflow-auto">
      <div class="col-sm-12">
        <table id="patient-table" class="table table-striped table-bordered align-middle mb-0 nowrap dataTable no-footer dtr-inline" style="width: 100%;" role="grid" aria-describedby="patient-table_info">
          <thead>
            <tr role="row">
              <th class="text-center">
                Mətn
              </th>
              <th class="text-center">
                Ad
              </th>
              <th class="text-center" v-if="user.role=='Admin'">
                partnerId
              </th>
              <th class="text-center">
                status
              </th>
              <th class="text-center">
                Redaktə
              </th>
            </tr>
          </thead>
          <tbody>                                    
            <tr v-for="template in templates" :key="template.id" class="text-center">
              <td>{{ template.content }}</td>
              <td>{{ template.name }}</td>
              <td v-if="user.role=='Admin'">{{ template.partnerId }}</td>
              <td>{{ template.status }}</td>
              <!-- Update -->
              <td>
                <button type="button" class="btn btn-outline-secondary" @click="toUpdateTemplate(template)"><i class="icofont-edit text-success"></i></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <br>
    <pagination
      :totalPages="leng"
      :perPage="request.pageSize"
      :currentPage="request.currentPage"
      @pagechanged="onPageChange"
    />

  </div>
</template>

<script>
import jwtInterceptor from '../../jwt.interceptor'
import user from '../../store/user'
import Pagination from '../parts/site/Pagination.vue'

export default {
  name: 'MessageTemplates',
  components: {
    Pagination
  },
  data() {
    return {
      templates: [],
      request: {
        pageNumber:1,
        pageSize:10,
      },
      totalCount:0,
      leng: 0,
    }
  },
  methods: {

    toUpdateTemplate(template) {
      user.dispatch('prepareUpdateTemplate', template)
      this.$router.push('updateShablonStatus')
    },
    onPageChange(page) {
      this.request.pageNumber = page;
      this.getTemplates();
    },
    getTemplates() {
      var url = '/SmShablons';
      if(this.user.role === 'Partner'){
        url+= "/GetAllPagedByUserId/" + this.user.id;
        this.request.userId = this.user.id;
      }
      jwtInterceptor.get(this.$store.getters.getUrl+url, { params: this.request}).
      then(response => {
        this.templates = response.data.result.items;
        this.totalCount = response.data.result.totalCount;
        this.leng = response.data.result.totalPages;
      })
      .catch(error => {
        console.log(error)
        this.$toast.error('Xəta baş verdi!', {
          position: "top-right"
        })
      })
    },
  },
  created() {
    this.user = user.getters.getUser
    this.getTemplates()
  }
}
</script>

<style>
[data-theme="high-contrast"] {
  .table-striped>tbody>tr:nth-of-type(odd)>* {
    color: white !important;
  }
}
</style>